import { render, staticRenderFns } from "./EditGoogleTagManager.vue?vue&type=template&id=2752ca46&"
import script from "./EditGoogleTagManager.vue?vue&type=script&lang=js&"
export * from "./EditGoogleTagManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports